/**
 * MinistrareIA - Onboarding Service
 * API calls for onboarding and channel selection
 */
import api from './api';

const onboardingService = {
  /**
   * Select channel during onboarding
   * @param {string} channel - "wa_personal" or "wa_business"
   * @returns {Promise<{user: object, redirect: string}>}
   */
  async selectChannel(channel) {
    const response = await api.post('/api/users/me/select-channel', {
      channel,
    });
    return response.data;
  },

  /**
   * Update default channel (for switching later)
   * @param {string} channel - "wa_personal" or "wa_business"
   * @returns {Promise<{user: object, redirect: string}>}
   */
  async updateDefaultChannel(channel) {
    const response = await api.put('/api/users/me/default-channel', {
      channel,
    });
    return response.data;
  },

  /**
   * Get onboarding status
   * @returns {Promise<{onboarding_completed: boolean, default_channel: string|null, redirect: string}>}
   */
  async getOnboardingStatus() {
    const response = await api.get('/api/users/me/onboarding-status');
    return response.data;
  },

  /**
   * Get redirect path based on user data
   * @param {object} user - User object
   * @returns {string} - Redirect path
   */
  getRedirectPath(user) {
    if (!user) return '/login';
    
    const onboardingCompleted = user.onboarding_completed ?? false;
    const defaultChannel = user.default_channel;

    if (!onboardingCompleted) {
      return '/onboarding';
    }

    if (defaultChannel === 'wa_personal') {
      return '/inbox';
    }

    if (defaultChannel === 'wa_business') {
      return '/wa-business';
    }

    // Fallback - onboarding completed but no channel (shouldn't happen)
    return '/onboarding';
  },

  /**
   * Check if user needs onboarding
   * @param {object} user - User object
   * @returns {boolean}
   */
  needsOnboarding(user) {
    if (!user) return true;
    return !user.onboarding_completed;
  },
};

export default onboardingService;
